import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import GarudaLogo from "../../images/garuda-logo.png";
import SignInButton from "../../pages/Home/components/SignInButton";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./Header.module.css";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Hidden, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { Routes } from "../../routes/routes";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faBook,
  faBookAtlas,
  faMicrophone,
  faAngleUp,
  faTools,
  faFileVideo,
  faWalkieTalkie,
  faBars,
  faClose,
  IconDefinition,
  faHome,
  faExchange,
  faDownload,
  faQuestionCircle,
  faArchive
} from "@fortawesome/free-solid-svg-icons";
import SignUpButton from "../../pages/Home/components/SignUpButton";
import { useAppDispatch, useAppSelector } from "../../common/state/hooks";
import { update } from "../../common/state/Slices/HeaderMenuSlice";
import IFrameModal from "../IFrameModal";
import { scrollToSection, scrollToTop } from "../../helper/utils";
import { GadgetPlaform } from "../../pages/Home/components/gadgets/GadgetPlaform";

declare const genv: any;

const isResourceMenuActive = (menuItem: Routes) =>
  menuItem === Routes.KNOWLEDGE_BASE ||
  menuItem === Routes.CHANGELOG ||
  menuItem === Routes.ABOUT_GADGET_BUILDER ||
  menuItem === Routes.HELP_SUPPORT;
const isCaseStudiesActive = (menuItem: Routes) =>
  menuItem === Routes.CASE_STUDIES_PRISM ||
  menuItem === Routes.CASE_STUDIES_SHIMADZU;

export default function Header() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { platform = GadgetPlaform.WINDOWS } = useParams();
  const isAuthenticated = useAppSelector((state) => state.auth.authenticated);
  const selectedMenu = useAppSelector((state) => state.headerMenuSlice.selectedMenu);
  const [anchorElResource, setAnchorElResource] = useState<null | HTMLElement>(null);
  const [caseStudiesmenuAnchorEl, setCaseStudiesMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [archivemenuAnchorEl, setArchiveMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [isResourceClicked, setIsHelpSupportClicked] = useState<boolean>(false);
  const [isCaseStudiesClicked, setIsCaseStudiesClicked] = useState<boolean>(false);
  const [isArchiveClicked, setIsArchiveClicked] = useState<boolean>(false);
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const [confluenceModalContent, setConfluenceModalContent] = useState("");
  const [confluenceModalIsOpen, setConfluenceModalIsOpen] = useState(false);
  const [navMenuIcon, setNavMenuIcon] = useState<IconDefinition>(faBars);
  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
    setNavMenuIcon(faClose);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
    setNavMenuIcon(faBars);
  }
  
  const handleOpenHelpSupportMenu = (event: React.MouseEvent<HTMLElement>) => {
    setIsHelpSupportClicked(true);
    setAnchorElResource(event.currentTarget);
    handleCloseCaseStudiesMenu();
    handleCloseArchiveMenu();
  };

  const handleCloseConfluenceModal = () => {
    setConfluenceModalIsOpen(false);
    setConfluenceModalContent("");
  };

  const handleKnowledgeBase = (url: string) => {
    if (url) {
      setConfluenceModalContent(url);
      setConfluenceModalIsOpen(true);
    }
  };

  const handleCloseHelpSupportMenu = () => {
    setIsHelpSupportClicked(false);
    setAnchorElResource(null);
  };

  const handleCloseArchiveMenu = () => {
    setIsArchiveClicked(false);
    setArchiveMenuAnchorEl(null);
  };

  const handleCloseCaseStudiesMenu = () => {
    setIsCaseStudiesClicked(false);
    setCaseStudiesMenuAnchorEl(null);
  };

  const handleCaseStudiesMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setIsCaseStudiesClicked(true);
    setCaseStudiesMenuAnchorEl(event.currentTarget);
    handleCloseHelpSupportMenu();
    handleCloseArchiveMenu();
  };

  const handleArchiveMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setIsArchiveClicked(true);
    setArchiveMenuAnchorEl(event.currentTarget);
    handleCloseHelpSupportMenu();
    handleCloseCaseStudiesMenu();
  };

  const handleHelpSupportMenuNavigation = (route: Routes) => {
    navigateToPage(route);
    handleCloseHelpSupportMenu();
    handleCloseArchiveMenu();
  };

  const navigateToHomePage = () => {
    dispatch(
      update({
        selectedMenu: Routes.HOME,
      })
    );
    navigate(`/platform/${platform}`);
  };

  const navigateToPage = (route: Routes) => {
    dispatch(
      update({
        selectedMenu: route,
      })
    );
    navigate(route);
  };

  const helpSupportMenus: any = [
    {
      title: "Agent Builder",
      description: "How to garudify your tool",
      route: Routes.ABOUT_GADGET_BUILDER,
      icon: faTools,
      onClick: (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        handleHelpSupportMenuNavigation(Routes.ABOUT_GADGET_BUILDER);
      },
    },
    {
      title: "Knowledge base",
      description: "Get to know more about Garuda",
      route: Routes.KNOWLEDGE_BASE,
      icon: faBook,
      onClick: (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        handleKnowledgeBase(genv.GARUDA_FUNCTIONAL_DOC_LINK);
      },
    },
    {
      title: "Changelog",
      description: "A brief about Garuda releases",
      route: Routes.CHANGELOG,
      icon: faBookAtlas,
      onClick: (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        handleHelpSupportMenuNavigation(Routes.CHANGELOG);
      },
    },
    {
      title: "Contact Us",
      description: "Reach out to the Garuda Team",
      route: Routes.HELP_SUPPORT,
      icon: faMicrophone,
      onClick: (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        handleHelpSupportMenuNavigation(Routes.HELP_SUPPORT);
      },
    },
  ];

  return (
    <AppBar position="static" color="transparent" className={styles.appbar}>
      <IFrameModal
        modalContent={confluenceModalContent}
        handleCloseModal={handleCloseConfluenceModal}
        isModalOpen={confluenceModalIsOpen}
      />
      <Toolbar disableGutters>
        <div className={styles.container}>
          <img
            className={styles.garudaLogo}
            src={GarudaLogo}
            alt=""
            onClick={() => {
              navigateToHomePage();
              setTimeout(() => {
                scrollToTop();
              }, 100);
            }}
          />
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', lg: 'none' }, justifyContent: "end"}}>
            <IconButton
              size="large"
              aria-label="header menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <FontAwesomeIcon icon={navMenuIcon} color="#44bcdb"/>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              <MenuItem key={"Home"} onClick={() => {
                handleCloseNavMenu();
                navigateToHomePage();
              }}>
                <Typography>
                  <FontAwesomeIcon icon={faHome} className={styles.navMenuIcon}/>
                  {"Home"}
                </Typography>
              </MenuItem>
              <MenuItem key={"Recipes"} onClick={() => {
                handleCloseNavMenu();
                navigateToPage(Routes.ABOUT_RECIPE);
              }}>
                <Typography>
                  <FontAwesomeIcon icon={faExchange} className={styles.navMenuIcon}/>
                  {"Recipes"}
                </Typography>
              </MenuItem>
              <Accordion>
                <AccordionSummary
                  expandIcon={<FontAwesomeIcon icon={faAngleDown}/>}
                  aria-controls="case-studies-content"
                  id="case-studies-header"
                >
                  <Typography component="span">
                    <FontAwesomeIcon icon={faBook} className={styles.navMenuIcon}/>
                    {"Case Studies"}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <MenuItem
                    key={"Prism"}
                    onClick={() => {
                      handleCloseNavMenu();
                      navigateToPage(Routes.CASE_STUDIES_PRISM);
                    }}
                  >
                    <Typography>{"Prism"}</Typography>
                  </MenuItem>
                  <MenuItem
                    key={"Shimadzu"}
                    onClick={() => {
                      handleCloseNavMenu();
                      navigateToPage(Routes.CASE_STUDIES_SHIMADZU);
                    }}
                  >
                    <Typography>{"Shimadzu"}</Typography>
                  </MenuItem>
                </AccordionDetails>
              </Accordion>
              <MenuItem key={"Downloads"} onClick={() => {
                handleCloseNavMenu();
                navigateToPage(Routes.DOWNLOADS);
              }}>
                <Typography>
                  <FontAwesomeIcon icon={faDownload} className={styles.navMenuIcon}/>
                  {"Downloads"}
                </Typography>
              </MenuItem>
              <Accordion>
                <AccordionSummary
                  expandIcon={<FontAwesomeIcon icon={faAngleDown}/>}
                  aria-controls="help-support-content"
                  id="help-support-header"
                >
                  <Typography component="span">
                    <FontAwesomeIcon icon={faQuestionCircle} className={styles.navMenuIcon}/>
                    {"Help & Support"}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <MenuItem
                    key={"Agent Builder"}
                    onClick={() => {
                      handleCloseNavMenu();
                      navigateToPage(Routes.ABOUT_GADGET_BUILDER);
                    }}
                  >
                    <Typography>{"Agent Builder"}</Typography>
                  </MenuItem>
                  <MenuItem
                    key={"Knowledge Base"}
                    onClick={() => {
                      handleCloseNavMenu();
                      handleKnowledgeBase(genv.GARUDA_FUNCTIONAL_DOC_LINK);
                    }}
                  >
                    <Typography>{"Knowledge Base"}</Typography>
                  </MenuItem>
                  <MenuItem
                    key={"Changelog"}
                    onClick={() => {
                      handleCloseNavMenu();
                      navigateToPage(Routes.CHANGELOG);
                    }}
                  >
                    <Typography>{"Changelog"}</Typography>
                  </MenuItem>
                  <MenuItem
                    key={"Contact Us"}
                    onClick={() => {
                      handleCloseNavMenu();
                      navigateToPage(Routes.HELP_SUPPORT);
                    }}
                  >
                    <Typography>{"Contact Us"}</Typography>
                  </MenuItem>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<FontAwesomeIcon icon={faAngleDown}/>}
                  aria-controls="archive-content"
                  id="archive-header"
                >
                  <Typography component="span">
                    <FontAwesomeIcon icon={faArchive} className={styles.navMenuIcon}/>
                    {"Archive"}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <MenuItem
                    key={"Garuda 1x Legacy"}
                    onClick={() => window.open(genv.GARUDA_1X_LEGACY_LINK, "_blank")}
                  >
                    <Typography>{"Garuda 1x Legacy"}</Typography>
                  </MenuItem>
                  <MenuItem
                    key={"Garuda Alliance and Community Initiatives"}
                    onClick={() => window.open(genv.GARUDA_ALLIANCE_COMMUNITY_LINK, "_blank")}
                  >
                    <Typography className={styles.textWrap}>{"Garuda Alliance & Community Initiatives"}</Typography>
                  </MenuItem>
                </AccordionDetails>
              </Accordion>
            </Menu>
          </Box>
          <Hidden lgDown>
            <Grid container className={styles.gridContainer}>
              <Grid item xs={8} className={styles.navbarContainer}>
                <Button
                  key={"Home"}
                  className={styles.navbarButton}
                  onClick={() => {
                    navigateToHomePage();
                    setTimeout(() => {
                      scrollToTop();
                    }, 100);
                  }}
                >
                  <Typography 
                    variant="subtitle1"
                    className={
                      selectedMenu === Routes.HOME
                        ? styles.activeMenu
                        : styles.menu
                    }
                  >
                    Home
                  </Typography>
                </Button>
                <Button
                  key={"agents"}
                  className={styles.navbarButton}
                  onClick={() => {
                    navigateToHomePage();
                    setTimeout(() => {
                      scrollToSection("agents");
                    }, 100);
                  }}
                >
                  <Typography variant="subtitle1" className={styles.menu}>Agents</Typography>
                </Button>
                <Button
                  key={"Recipes"}
                  className={styles.navbarButton}
                  onClick={() => navigateToPage(Routes.ABOUT_RECIPE)}
                >
                  <Typography 
                    variant="subtitle1"
                    className={
                      selectedMenu === Routes.ABOUT_RECIPE
                        ? styles.activeMenu
                        : styles.menu
                    }
                  >
                    Recipes
                  </Typography>
                </Button>
                <Button
                  onClick={handleCaseStudiesMenuOpen}
                  key={"Case Studies"}
                  className={styles.navbarButton}
                  sx={{
                    ".MuiButton-endIcon": {
                      marginLeft: 0,
                    },
                  }}
                  endIcon={
                    <FontAwesomeIcon
                      className={styles.endIcon}
                      style={{
                        color: isCaseStudiesActive(selectedMenu)
                          ? "#44bcdb"
                          : "#454545",
                      }}
                      icon={isCaseStudiesClicked ? faAngleUp : faAngleDown}
                    />
                  }
                >
                  <Typography 
                    variant="subtitle1"
                    className={
                      isCaseStudiesActive(selectedMenu)
                        ? styles.activeMenu
                        : styles.menu
                    }
                  >
                    Case Studies
                  </Typography>
                </Button>
                <Menu
                  sx={{ mt: "50px", ml: "3.2rem" }}
                  id="case-studies-menu-appbar"
                  anchorEl={caseStudiesmenuAnchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  hideBackdrop={true}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  open={Boolean(caseStudiesmenuAnchorEl)}
                  onClose={handleCloseCaseStudiesMenu}
                  onClick={handleCloseCaseStudiesMenu}
                >
                  <MenuItem
                    key={"Shimadzu"}
                    onClick={() => {
                      setIsCaseStudiesClicked(false);
                      navigateToPage(Routes.CASE_STUDIES_SHIMADZU);
                    }}
                  >
                    <FontAwesomeIcon icon={faWalkieTalkie} />
                    <div className={styles.menuItem}>
                      <Typography variant="body2" className={styles.menuItemText}>
                        {"Shimadzu"}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className={styles.menuItemText}
                      >
                        {"Shimadzu Multi-omics Analysis Package"}
                      </Typography>
                    </div>
                  </MenuItem>
                  <MenuItem
                    key={"Prism"}
                    onClick={() => {
                      setIsCaseStudiesClicked(false);
                      navigateToPage(Routes.CASE_STUDIES_PRISM);
                    }}
                  >
                    <FontAwesomeIcon icon={faFileVideo} />
                    <div className={styles.menuItem}>
                      <Typography variant="body2" className={styles.menuItemText}>
                        {"Prism"}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className={styles.menuItemText}
                      >
                        {"Miné Platform Built on Garuda"}
                      </Typography>
                    </div>
                  </MenuItem>
                </Menu>
                <Tooltip title="Get the Trial Version of Garuda">
                  <Button
                    key={"Downloads"}
                    className={styles.navbarButton}
                    onClick={() => navigateToPage(Routes.DOWNLOADS)}
                  >
                    <Typography 
                      variant="subtitle1"
                      className={
                        selectedMenu === Routes.DOWNLOADS
                          ? styles.activeMenu
                          : styles.menu
                      }
                    >
                      Downloads
                    </Typography>
                  </Button>
                </Tooltip>
                <Button
                  onClick={handleOpenHelpSupportMenu}
                  className={styles.navbarButton}
                  sx={{
                    ".MuiButton-endIcon": {
                      marginLeft: 0,
                    },
                  }}
                  endIcon={
                    <FontAwesomeIcon
                      className={styles.endIcon}
                      style={{
                        color: isResourceMenuActive(selectedMenu)
                          ? "#44bcdb"
                          : "#454545",
                      }}
                      icon={isResourceClicked ? faAngleUp : faAngleDown}
                    />
                  }
                  key={"Help & Support"}
                >
                  <Typography 
                    variant="subtitle1"
                    className={
                      isResourceMenuActive(selectedMenu)
                        ? styles.activeMenu
                        : styles.menu
                    }
                  >
                    Help & Support
                  </Typography>
                </Button>
                <Menu
                  sx={{ mt: "50px" }}
                  id="menu-appbar"
                  anchorEl={anchorElResource}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  hideBackdrop={true}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  open={Boolean(anchorElResource)}
                  onClose={handleCloseHelpSupportMenu}
                  onClick={handleCloseHelpSupportMenu}
                >
                  {helpSupportMenus.map((menu: any, index: number) => (
                    <MenuItem key={menu.title} onClick={menu.onClick}>
                      <FontAwesomeIcon icon={menu.icon} />
                      <div className={styles.menuItem}>
                        <Typography
                          variant="body2"
                          className={styles.menuItemText}
                        >
                          {menu.title}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          className={styles.menuItemText}
                        >
                          {menu.description}
                        </Typography>
                      </div>
                    </MenuItem>
                  ))}
                </Menu>
                <Button
                  onClick={handleArchiveMenuOpen}
                  key={"Archive"}
                  className={styles.navbarButton}
                  sx={{
                    ".MuiButton-endIcon": {
                      marginLeft: 0,
                    },
                  }}
                  endIcon={
                    <FontAwesomeIcon
                      className={styles.endIcon}
                      style={{
                        color: "#454545"
                      }}
                      icon={isArchiveClicked ? faAngleUp : faAngleDown}
                    />
                  }
                >
                  <Typography 
                    variant="subtitle1"
                    className={styles.menu}
                  >
                    Archive
                  </Typography>
                </Button>
                <Menu
                  sx={{ mt: "50px", ml: "5rem" }}
                  id="case-studies-menu-appbar"
                  anchorEl={archivemenuAnchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  hideBackdrop={true}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  open={Boolean(archivemenuAnchorEl)}
                  onClose={handleCloseArchiveMenu}
                  onClick={handleCloseArchiveMenu}
                >
                  <MenuItem
                    key={"Garuda 1x Legacy"}
                    onClick={() => window.open(genv.GARUDA_1X_LEGACY_LINK, "_blank")}
                  >
                    <FontAwesomeIcon icon={faWalkieTalkie} />
                    <div className={styles.menuItem}>
                      <Typography variant="body2" className={styles.menuItemText}>
                        {"Garuda 1x"}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className={styles.menuItemText}
                      >
                        {"Explore the legacy version of Garuda"}
                      </Typography>
                    </div>
                  </MenuItem>
                  <MenuItem
                    key={"Garuda Alliance and Community Initiatives"}
                    onClick={() => window.open(genv.GARUDA_ALLIANCE_COMMUNITY_LINK, "_blank")}
                  >
                    <FontAwesomeIcon icon={faFileVideo} />
                    <div className={styles.menuItem}>
                      <Typography variant="body2" className={styles.menuItemText}>
                        {"Garuda Alliance"}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className={styles.menuItemText}
                      >
                        {"Garuda Alliance and Community Initiatives"}
                      </Typography>
                    </div>
                  </MenuItem>
                </Menu>
              </Grid>
              <Grid item xs={4} className={styles.buttonGridContainer}>
                <div className={styles.buttonContainer}>
                  {!isAuthenticated && <SignUpButton />}
                  <SignInButton />
                </div>
              </Grid>
            </Grid>
          </Hidden>
        </div>
      </Toolbar>
    </AppBar>
  );
}
